<template>
    <div id="copyserviceorderproductpage">
        <ui5-button
            id="saveCopyServiceOrderProduct"
            @click="saveCopyServiceOrderProduct"
            style="width: 200px"
        >
            {{ trans('pages.copeserviceorderproduct.save_button') }}
        </ui5-button>
        <ui5-button
            id="cancelCopyServiceOrderProduct"
            @click="
                $router.push(
                    '/editproduct/?orderId=' +
                        $route.query.orderId +
                        '&productTypeId=' +
                        $route.query.typeId +
                        '&productId=' +
                        $route.query.productId
                )
            "
            style="width: 200px"
        >
            {{ trans('pages.copeserviceorderproduct.cancel_button') }}
        </ui5-button>

        <div style="clear: both" />

        <!-- Div containing the default fields -->
        <div
            class="fieldsdiv"
            id="editproductdefaultfields"
        ></div>
        <!--  Div containing options to link to retour -->
        <div
            class="fieldsdiv"
            id="retourproductfield"
        ></div>
        <!-- Div containing the dynamic fields -->
        <div
            class="fieldsdiv"
            id="editproductfields"
        ></div>
    </div>
</template>
<style
    lang="scss"
    scoped
>
.fieldsdiv {
    margin-top: 16px;
}
.addproductfield {
    margin: 5px;
    input[type='checkbox'] {
        transform: none;
    }
}
#retourproductfield {
    label {
        width: 250px;
        font-style: normal;
        display: inline-block;
    }
}
#editproductfields {
    label {
        width: 230px;
        display: inline-block;
        font-style: normal;
    }
    input[type='text'] {
        width: 320px;
    }
    input[type='number'] {
        width: 320px;
    }
    select {
        width: 320px;
    }
    textarea {
        width: 320px;
    }
}
#editproductdefaultfields {
    label {
        width: 230px;
        display: inline-block;
        font-style: normal;
    }
    input[type='text'] {
        width: 320px;
    }
    input[type='number'] {
        width: 320px;
    }
    select {
        width: 320px;
    }
}
#editNoteField {
    width: 65%;
    margin: 5px;
    height: 50px;
    margin-left: 0px;
    font-size: 11px;
}
#noteField {
    width: 65%;
    margin: 5px;
    height: 50px;
    margin-left: 0px;
    font-size: 11px;
}
</style>
<script>
import productApi from '../api/product';
import productTypeApi from '../api/productType';
import genericApi from '../api/generic';
import colorApi from '../api/color';
import { isFunction } from '../helpers/GeneralHelper';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

function ErpMap(trans) {
    // members
    this.keyArray = []; // Keys
    this.valArray = []; // Values

    // methods
    this.put = put;
    this.get = get;
    this.size = size;
    this.clear = clear;
    this.keySet = keySet;
    this.valSet = valSet;
    this.showMe = showMe; // returns a string with all keys and values in map.
    this.findIt = findIt;
    this.remove = remove;

    function put(key, val) {
        var elementIndex = this.findIt(key);

        if (elementIndex == -1) {
            this.keyArray.push(key);
            this.valArray.push(val);
        } else {
            this.valArray[elementIndex] = val;
        }
    }

    function get(key) {
        var result = null;
        var elementIndex = this.findIt(key);

        if (elementIndex != -1) {
            result = this.valArray[elementIndex];
        }

        return result;
    }

    function remove(key) {
        var result = null;
        var elementIndex = this.findIt(key);

        if (elementIndex != -1) {
            this.keyArray = removeAt(this.keyArray, elementIndex);
            this.valArray = removeAt(this.valArray, elementIndex);
        }

        return;
    }

    function size() {
        return this.keyArray.length;
    }

    function clear() {
        for (var i = 0; i < this.keyArray.length; i++) {
            this.keyArray.pop();
            this.valArray.pop();
        }
    }

    function keySet() {
        return this.keyArray;
    }

    function valSet() {
        return this.valArray;
    }

    function showMe() {
        var result = '';

        for (var i = 0; i < this.keyArray.length; i++) {
            result +=
                'Key: ' +
                this.keyArray[i] +
                '\tValues: ' +
                this.valArray[i] +
                '\n';
        }
        return result;
    }

    function findIt(key) {
        var result = -1;

        for (var i = 0; i < this.keyArray.length; i++) {
            if (this.keyArray[i] == key) {
                result = i;
                break;
            }
        }
        return result;
    }

    function removeAt(arr, index) {
        var part1 = arr.slice(0, index);
        var part2 = arr.slice(index + 1);
        return part1.concat(part2);
    }
}

function setValForField(fieldId, value, description) {
    if ($('#' + fieldId).is(':input')) {
        $('#' + fieldId).val(value);
    } else {
        $('#' + fieldId).text(value);
    }

    $('#description' + fieldId).text(description || '');
}

const ProductHelper = (function () {
    var dataTypes = {
        boolean: 1,
        int: 2,
        string: 3,
        options: 4,
        double: 5,
        table: 6,
        textarea: 7,
        popup: 8,
        multiselect: 9,
    };

    //Certain producttypes need a bigger notefield
    var producttypes = ['4', '5', '30', '39'];
    function adjustNoteFieldHeight(ptId) {
        if (include(producttypes, ptId)) {
            $('#noteField, #editNoteField').css('height', '250px');
        }

        function include(arr, obj) {
            return arr.indexOf(obj) > -1;
        }
    }

    function renderMultiselect(multiSelect, currentValue) {
        var multiSelectOutput = '';
        var dataFieldId = multiSelect.datafieldId;
        var defaultValues = currentValue.split('%');

        $.each(multiSelect.multiSelectOptions, function (optionIndex) {
            var optionHtml = '';

            if ($.inArray(this.valueOf(), defaultValues) == -1) {
                optionHtml =
                    '<input type="checkbox" name="' +
                    dataFieldId +
                    '" value="' +
                    this.key +
                    '">' +
                    this.value;
            } else {
                optionHtml =
                    '<input type="checkbox" name="' +
                    dataFieldId +
                    '" value="' +
                    this.key +
                    '" checked>' +
                    this.value;
            }

            multiSelectOutput +=
                '<div style="position: relative; left: 230px;">' +
                optionHtml +
                '</div>';
        });
        return multiSelectOutput;
    }

    function renderInt(field, currentValue) {
        return (
            '<input type="number" name="' +
            field.datafieldId +
            '" id="' +
            field.datafieldId +
            '" value="' +
            currentValue +
            '"  />'
        );
    }

    function renderDouble(field, currentValue) {
        return (
            '<input type="number" name="' +
            field.datafieldId +
            '" id="' +
            field.datafieldId +
            '" value="' +
            currentValue +
            '"  />'
        );
    }

    function renderBool(field, currentValue) {
        if (currentValue == 1) {
            return (
                '<input checked type="checkbox" name="' +
                field.datafieldId +
                '" id="' +
                field.datafieldId +
                '" class="custom" />'
            );
        } else {
            return (
                '<input type="checkbox" name="' +
                field.datafieldId +
                '" id="' +
                field.datafieldId +
                '" class="custom" />'
            );
        }
    }

    function renderOptions(field, currentValue) {
        var html =
            '<select name="' +
            field.datafieldId +
            '" id="' +
            field.datafieldId +
            '">';

        var length = field.fielddata.length;
        for (var j = 0; j < length; j++) {
            var fielddatum = field.fielddata[j];

            if (fielddatum.dataoption == currentValue) {
                html +=
                    '<option selected value="' +
                    fielddatum.dataoption +
                    '">' +
                    fielddatum.dataoption +
                    '</option>';
            } else {
                html +=
                    '<option value="' +
                    fielddatum.dataoption +
                    '">' +
                    fielddatum.dataoption +
                    '</option>';
            }
        }

        html += '</select>';

        return html;
    }

    function renderTextarea(field, currentValue) {
        return (
            '<textarea name="' +
            field.datafieldId +
            '" id="' +
            field.datafieldId +
            '" value=""  >' +
            currentValue +
            '</textarea>'
        );
    }

    function renderString(field, currentValue) {
        return (
            '<input type="text" name="' +
            field.datafieldId +
            '" id="' +
            field.datafieldId +
            '" value="' +
            currentValue +
            '"  />'
        );
    }

    function renderTable(field, currentValue) {
        var html =
            '<input type="text" name="' +
            field.datafieldId +
            '" id="' +
            field.datafieldId +
            '" value="' +
            currentValue +
            '"  readonly/><span id="description' +
            field.datafieldId +
            '">' +
            (field.fieldvaluedescription || '') +
            '</span><br/>';

        //generate two fields to filter on based on the data from the db
        //The names of the fields are tableField and tableField2
        //Also use these names as id's for the fields
        html +=
            '<input class="changeGeneric" type="text" name="' +
            field.tableField +
            '" id="' +
            field.tableField +
            '" value="" placeholder="' +
            field.tableFieldName +
            '" />';

        html +=
            '<input class="changeGeneric" type="text" name="' +
            field.tableField2 +
            '" id="' +
            field.tableField2 +
            '" value="" placeholder="' +
            field.tableFieldName2 +
            '"/>';

        html +=
            '<ul id="list' +
            field.datafieldId +
            '" class="genericListUl"></ul>';

        return html;
    }

    function renderPopup(field, currentValue) {
        var html =
            '<input type="text" name="' +
            field.datafieldId +
            '" id="' +
            field.datafieldId +
            '" value="' +
            currentValue +
            '"  readonly/><span id="description' +
            field.datafieldId +
            '">' +
            (field.fieldvaluedescription || '') +
            '</span><br/>';
        //generate two fields to filter on based on the data from the db
        //The names of the fields are tableField and tableField2
        //Also use these names as id's for the fields
        html +=
            '<input class="changeGeneric" type="text" name="' +
            field.tableField +
            '" id="' +
            field.tableField +
            '" value="" placeholder="' +
            field.tableFieldName +
            '" />';

        html +=
            '<input class="changeGeneric" type="text" name="' +
            field.tableField2 +
            '" id="' +
            field.tableField2 +
            '" value="" placeholder="' +
            field.tableFieldName2 +
            '"/>';

        html +=
            '<ul id="list' +
            field.datafieldId +
            '" class="genericListUl"></ul>';
        return html;
    }

    var mandatoryHtml = "<span class='mandatory'>*</span>";
    function createLabel(field) {
        var style =
            parseInt(field.datatype) == dataTypes['multiselect']
                ? ' style="position: absolute;"'
                : '';
        var mandatory = field.mandatory == 1 ? mandatoryHtml : '';
        return (
            '<label for="' +
            field.datafieldId +
            '"' +
            style +
            '>' +
            field.label +
            mandatory +
            '</label>'
        );
    }

    function renderElement(field, currentValue) {
        switch (parseInt(field['datatype'])) {
            case dataTypes['int']:
                return renderInt(field, currentValue);
            case dataTypes['double']:
                return renderDouble(field, currentValue);
            case dataTypes['options']:
                return renderOptions(field, currentValue);
            case dataTypes['boolean']:
                return renderBool(field, currentValue);
            case dataTypes['multiselect']:
                return renderMultiselect(field, currentValue);
            case dataTypes['table']:
                return renderTable(field, currentValue);
            case dataTypes['popup']:
                return renderPopup(field, currentValue);
            case dataTypes['textarea']:
                return renderTextarea(field, currentValue);
            case dataTypes['string']:
            default:
                return renderString(field, currentValue);
        }
    }

    function loadFields(fields, currentValuePropertyName) {
        var changeGenericCallback = function (
            fieldId,
            tblKey,
            description,
            clickedElement
        ) {
            setValForField(fieldId, tblKey, description);
            var parentUl = clickedElement.closest('.genericListUl');
            parentUl.empty();
            parentUl.prevAll('.changeGeneric').val('');
        };

        var productFieldsElement = $('#editproductfields');

        productFieldsElement.empty();

        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];

            var label = createLabel(field);

            var currentValue = field[currentValuePropertyName];
            currentValue = !currentValue ? '' : currentValue;

            var element = renderElement(field, currentValue);

            var wrapperStyle =
                parseInt(field.datatype) == dataTypes['multiselect']
                    ? ' style="overflow-y: scroll; overflow-x: hidden; max-height: 300px;"'
                    : '';

            var productfieldHtml =
                '<div class="addproductfield"' +
                wrapperStyle +
                '>' +
                label +
                element +
                '</div>';

            var renderedElement = $(productfieldHtml);

            productFieldsElement.append(renderedElement);

            if (field.name == 'width') {
                renderedElement.find(':input').addClass('productWidth');
            } else if (field.name == 'height') {
                renderedElement.find(':input').addClass('productHeight');
            }

            var genericChangeFields = renderedElement.find('.changeGeneric');
            if (genericChangeFields.length > 0) {
                genericChangeFields.data('datafield', field);

                genericChangeFields.on('change', function () {
                    var changeField = $(this).data('datafield');
                    changeGeneric(
                        changeField.table,
                        changeField.tableKey,
                        changeField.tableField,
                        changeField.tableField2,
                        changeField.tableFilter,
                        'list' + changeField.datafieldId,
                        changeField.datafieldId,
                        changeGenericCallback
                    );
                });
            }
        }
    }

    function getRetourHtml(data, retourProductId, trans) {
        //Load retour html if this is a service order
        var retourProductId = data.data.retourProductId;

        var retourHtml = '';

        var noRetourItemsMessage = `<p>${trans(
            'pages.copeserviceorderproduct.no_return_items'
        )}</p>`;

        retourHtml +=
            '<div class="addproductfield">' +
            `<label for="retourfield">${trans(
                'pages.copeserviceorderproduct.return_product'
            )}</label><input type="text" name="retourfield" id="retourfield"  value="` +
            retourProductId +
            '" readonly/>' +
            '</div>' +
            `<div id="retourproductlist">${trans(
                'pages.copeserviceorderproduct.select_return'
            )}`;

        if (data.data.retouritems) {
            var retourItems = data.data.retouritems;
            if (retourItems.length > 0) {
                for (var i = 0; i < retourItems.length; i++) {
                    retourHtml +=
                        '<li><a onClick=retourSelected("' +
                        retourItems[i].productId +
                        '") id="' +
                        retourItems[i].productId +
                        '" >' +
                        retourItems[i].productId +
                        ', ' +
                        retourItems[i].name +
                        ' ' +
                        retourItems[i].producttypeName +
                        '</a></li>';
                }
            } else {
                retourHtml += noRetourItemsMessage;
            }
        } else {
            retourHtml += noRetourItemsMessage;
        }

        retourHtml += '</div>';

        return retourHtml;
    }

    function getGroupWithOtherTypeHtml(groupItems, trans) {
        var html =
            '<div class="addproductfield">' +
            `<label for="linkToProductField">${trans(
                'pages.copeserviceorderproduct.selected_product'
            )}</label><input type="text" name="linkToProductField" id="linkToProductField" value=""  readonly/><button onClick=clearLinkProduct();>${trans(
                'pages.copeserviceorderproduct.clear'
            )}</button>` +
            '</div>' +
            '<div style="clear:both">' +
            `<p>${trans(
                'pages.copeserviceorderproduct.product_group_link'
            )}</p>` +
            '</div>';

        for (var i = 0; i < groupItems.length; i++) {
            var groupItem = groupItems[i];

            html +=
                '<li><a onClick=productForGroupSelected("' +
                groupItem.productId +
                '") id="' +
                groupItem.productId +
                '" >' +
                groupItem.productId +
                ', ' +
                groupItem.name +
                ' ' +
                groupItem.producttypeName +
                '</a></li>';
        }

        html += '<ul id="productlistlink"></ul>';

        return html;
    }

    // Are separate onChange handlers really necessary for input and edit??
    //  This is the main reason that getInputColorHtml() and getEditColorHtml(data) cannot be merged

    function getInputColorHtml(trans) {
        var selectColorInstruction = `<p>${trans(
            'pages.copeserviceorderproduct.select_color_instruction'
        )}</p>`;

        var html =
            '<div class="addproductfield">' +
            `<label for="colorField">${trans(
                'pages.copeserviceorderproduct.color'
            )}</label><input type="text" name="colorField" id="colorField" value=""  readonly/><label id="addproductcolorlbl"></label>` +
            '</div>' +
            '<div style="clear:both">' +
            selectColorInstruction +
            '</div>' +
            '<div class="grid-a">' +
            '<div class="block-a">' +
            '<div class="ui-hide-label" style="padding:5px;">' +
            `<label for="ralnrField">${trans(
                'pages.copeserviceorderproduct.ral_number'
            )}:</label>` +
            `<input onChange=onChangeInputRalnr() type="text" name="ralnrField" id="ralnrField" value="" placeholder="${trans(
                'pages.copeserviceorderproduct.ral_number'
            )}"/>` +
            '</div>' +
            '</div>' +
            '<div class="block-b">' +
            '<div class="ui-hide-label" style="padding:5px;">' +
            `<label for="raltypeField">${trans(
                'pages.copeserviceorderproduct.ral_type'
            )}:</label>` +
            `<input onChange=onChangeInputRaltype() type="text" name="raltypeField" id="raltypeField" value="" placeholder="${trans(
                'pages.copeserviceorderproduct.ral_type'
            )}"/>` +
            '</div>' +
            '</div>' +
            '</div> ' +
            '<ul id="inputcolorlist">' +
            '</ul>';

        return html;
    }

    function getEditColorHtml(data, trans) {
        var color = data.data.color.id;
        var ralnr = data.data.color.ralnr;
        var raltype = data.data.color.raltype;
        var poedernr = data.data.color.poedernr;

        if (color == null) {
            color = '';
            ralnr = '';
            raltype = '';
            poedernr = '';
        }

        var html =
            '<div class="addproductfield">' +
            `<label for="editColorField">${trans(
                'pages.copeserviceorderproduct.color'
            )}</label><input type="text" name="editColorField" id="editColorField" value="` +
            color +
            `"  readonly/><label id="editproductcolorlbl">` +
            poedernr +
            '</label>' +
            '</div>' +
            '<div style="clear:both">' +
            selectColorInstruction +
            '</div>' +
            '<div class="grid-a">' +
            '<div class="block-a">' +
            '<div class="hide-label" style="padding:5px;">' +
            `<label for="editRalnrField">${trans(
                'pages.copeserviceorderproduct.ral_number'
            )}:</label>` +
            `<input onChange=onChangeEditRalnr() type="text" name="editRalnrField" id="editRalnrField" value="` +
            ralnr +
            `" placeholder="${trans(
                'pages.copeserviceorderproduct.ral_number'
            )}"/>` +
            '</div>' +
            '</div>' +
            '<div class="block-b">' +
            '<div class="hide-label" style="padding:5px;">' +
            `<label for="editRaltypeField">${trans(
                'pages.copeserviceorderproduct.ral_type'
            )}:</label>` +
            `<input onChange=onChangeEditRaltype() type="text" name="editRaltypeField" id="editRaltypeField" value="` +
            raltype +
            `" placeholder="${trans(
                'pages.copeserviceorderproduct.ral_type'
            )}"/>` +
            '</div>' +
            '</div>' +
            '</div> ' +
            '<ul id="editcolorlist">' +
            '</ul>';

        return html;
    }

    var flowEndHtml = '</select></div>';

    function createOption(value, selected, label) {
        return (
            '<option value="' +
            value +
            '"' +
            selected +
            '>' +
            label +
            '</option>'
        );
    }

    function getFlowHtmlEdit(data, setToFlow, trans) {
        var html =
            '<div class="addproductfield">' +
            `<label for="flow">${trans(
                'pages.copeserviceorderproduct.flow'
            )}<span class="mandatory">*</span></label>` +
            '<select id="flow">' +
            '<option></option>'; //insert empty option as default to make sure nothing is selected yet

        //Select flow of product. If setToFlow variable != -1, the id in the setToFlow variable
        // has priority over the flow of the product
        var flows = data.data.flows;
        for (var i = 0; i < flows.length; i++) {
            var flow = flows[i];

            if (setToFlow == -1 && flow.flowId == data.data.flowId) {
                html += createOption(flow.flowId, ' selected', flow.label);
            } else if (setToFlow != -1 && flow.flowId == setToFlow) {
                html += createOption(flow.flowId, ' selected', flow.label);
            } else {
                html += createOption(flow.flowId, '', flow.label);
            }
        }

        html += flowEndHtml;

        return html;
    }

    function getFlowHtmlAdd(data, defaultFlow, trans) {
        var html =
            '<div class="addproductfield">' +
            `<label for="flow">${trans(
                'pages.copeserviceorderproduct.flow'
            )}<span class="mandatory">*</span></label>` +
            '<select id="flow">' +
            '<option></option>'; //insert empty option as default to make sure nothing is selected yet

        var flows = data.data.flows;
        for (var i = 0; i < flows.length; i++) {
            var flow = flows[i];

            if (defaultFlow != '' && defaultFlow == flow.label) {
                html += createOption(flow.flowId, ' selected', flow.label);
            } else {
                html += createOption(flow.flowId, '', flow.label);
            }
        }

        html += flowEndHtml;

        return html;
    }

    //called to load editproduct.html page
    var loadProductInputToEdit = function (pId, setToFlow, trans) {
        productApi.fetchProductDetails(pId).then((response) => {
            const data = response.data;
            //$('#productName').html(data.data.productId);
            const productDetails = data.data;
            $('#product-title').html(
                trans('pages.copeserviceorderproduct.edit_product', {
                    productNr: productDetails.productNr,
                })
            );

            $('#product-active').text(
                productDetails.productNr + ' ' + productDetails.producttypeName
            );
            var ptId = productDetails.producttypeId;

            //Default fields
            //also set default fields by using code
            var defaultHtml = '';

            defaultHtml +=
                '<div class="addproductfield">' +
                `<label for="editReferenceField">${trans(
                    'pages.copeserviceorderproduct.reference'
                )}<span class="mandatory">${trans(
                    'pages.copeserviceorderproduct.mandatory'
                )}</span></label><input type="text" name="editReferenceField" id="editReferenceField" value="` +
                productDetails.reference +
                '"  />' +
                '</div>' +
                '<div class="addproductfield">' +
                `<label for="editNameField">${trans(
                    'pages.copeserviceorderproduct.place'
                )}</label><input type="text" name="editNameField" id="editNameField" value="` +
                productDetails.name +
                '"  />' +
                '</div>';
            //only show price if user is admin
            const hasRight = window.vuexStore.getters['currentUser/hasRight'];
            if (hasRight('administration')) {
                defaultHtml +=
                    '<div class="addproductfield">' +
                    `<label for="editPriceField">${trans(
                        'pages.copeserviceorderproduct.price'
                    )}</label><input pattern="[0-9]+([\.,][0-9]+)?" step="0.01" name="editPriceField" id="editPriceField" value="` +
                    productDetails.price +
                    '"  />' +
                    '</div>';
            }

            //hide count field if count is not allowed for this producttype
            if (productDetails.allow_count == 0) {
                //also add count field but hide it, it's always one in this case
                defaultHtml +=
                    '<div class="addproductfield">' +
                    '<input type="hidden" name="countField" id="editCountField" value="' +
                    productDetails.count +
                    '"  />' +
                    '</div>';
            } else {
                defaultHtml +=
                    '<div class="addproductfield">' +
                    `<label for="editCountField">${trans(
                        'pages.copeserviceorderproduct.count'
                    )}</label><input type="number" name="countField" id="editCountField" value="` +
                    productDetails.count +
                    '"  />' +
                    '</div>';
            }

            defaultHtml += getSquaremetersHtml(data, trans);

            defaultHtml += getEditColorHtml(data, trans);

            defaultHtml += getFlowHtmlEdit(data, setToFlow, trans);

            defaultHtml +=
                '<div style="clear: both;"></div>' +
                `<div class="addproductfield"><label id="noteFieldLbl" for="editNoteField">${trans(
                    'pages.copeserviceorderproduct.notes'
                )}</label>` +
                '<textarea id="editNoteField">' +
                productDetails.note +
                '</textarea></div>';

            defaultHtml +=
                '<div class="addproductfield">' +
                `<label for="editExternalURLField">${trans(
                    'pages.copeserviceorderproduct.external_url'
                )}</label><input type="text" name="editExternalURLField" id="editExternalURLField" value="` +
                productDetails.externUrl +
                '"  />';

            //set html
            $('#editproductdefaultfields').html(defaultHtml);

            adjustNoteFieldHeight(ptId);

            $('#retourproductfield').html(
                getRetourHtml(data, productDetails.retourProductId, trans)
            );

            loadFields(productDetails.datafields, 'fieldvalue');

            setUpSquareMetersCalculation();
        });
    };

    //variable defaultflow contains the flow we should select by default
    var loadProducttypeInput = function (ptId, oId, defaultFlow, trans) {
        //Clear page before loading new data
        $('#editproductdefaultfields').empty();
        $('#retourproductfield').empty();
        $('#editproductfields').empty();

        productTypeApi.productTypeDetails(ptId, oId).then((response) => {
            const data = response.data;
            //Set title
            //$('#productTypeName').html(data.data.label);
            $('#product-title').text(
                trans('pages.copeserviceorderproduct.add_new', {
                    label: data.data.label,
                })
            );
            $('#product-active').text(
                trans('pages.copeserviceorderproduct.add_new', {
                    label: data.data.label,
                })
            );

            //Default fields
            //also set default fields by using code
            var defaultHtml = '';

            defaultHtml +=
                '<div class="addproductfield">' +
                `<label for="referenceField">${trans(
                    'pages.copeserviceorderproduct.reference'
                )}<span class="mandatory">${trans(
                    'pages.copeserviceorderproduct.mandatory'
                )}</span></label><input type="text" name="referenceField" id="referenceField" value=""  />` +
                '</div>' +
                '<div class="addproductfield">' +
                `<label for="nameField">${trans(
                    'pages.copeserviceorderproduct.place'
                )}</label><input type="text" name="nameField" id="nameField" value=""  />` +
                '</div>' +
                '<div class="addproductfield">' +
                `<label for="priceField">${trans(
                    'pages.copeserviceorderproduct.price'
                )}</label><input pattern="[0-9]+([\.,][0-9]+)?" step="0.01" name="priceField" id="priceField" value=""  />` +
                '</div>';
            //hide count field if count is not allowed for this producttype
            if (data.data.allow_count == 0) {
                //also add count field but make it hidden, count is always one in this case
                defaultHtml +=
                    '<div class="addproductfield">' +
                    '<input type="hidden" name="countField" id="countField" value="1"  />' +
                    '</div>';
            } else {
                defaultHtml +=
                    '<div class="addproductfield">' +
                    `<label for="countField">${trans(
                        'pages.copeserviceorderproduct.count'
                    )}</label><input type="number" name="countField" id="countField" value="1"  />` +
                    '</div>';
            }

            defaultHtml += getSquaremetersHtml(undefined, trans);

            defaultHtml += getInputColorHtml(trans);

            defaultHtml += getFlowHtmlAdd(data, defaultFlow, trans);

            defaultHtml +=
                '<div style="clear: both;"></div>' +
                `<div class="addproductfield"><label id="noteFieldLbl" for="noteField">${trans(
                    'pages.copeserviceorderproduct.notes'
                )}</label>` +
                '<textarea id="noteField"></textarea></div>';

            defaultHtml +=
                '<div class="addproductfield">' +
                `<label for="externalURLField">${trans(
                    'pages.copeserviceorderproduct.external_url'
                )}</label><input type="text" name="externalURLField" id="externalURLField" value=""  />` +
                '</div>';

            //load html to link to another product if necessary
            if (data.data.groupWithOtherType == '1') {
                defaultHtml += getGroupWithOtherTypeHtml(
                    data.data.groupitems,
                    trans
                );
            }

            //set html
            $('#editproductdefaultfields').html(defaultHtml);
            adjustNoteFieldHeight(ptId);

            $('#retourproductfield').html(getRetourHtml(data, ''));

            loadFields(data.data.datafields, 'defaultValue');

            setUpSquareMetersCalculation();
        });
    };

    function getSquaremetersHtml(data, trans) {
        return (
            '<div class="addproductfield">' +
            `<label for="squareMetersField">${trans(
                'pages.copeserviceorderproduct.square_meters'
            )}</label>` +
            '<input type="number" name="squareMetersField" id="squareMetersField" value="' +
            (data ? data.data.squaremeters : 0) +
            '" readonly/>' +
            '</div>'
        );
    }

    function setUpSquareMetersCalculation() {
        var ui = {
            width: $('.productWidth'),
            height: $('.productHeight'),
            squareMeters: $('#squareMetersField'),
        };

        if (ui.width.length && ui.height.length) {
            ui.width.on('change', updateSquareMeters);
            ui.height.on('change', updateSquareMeters);
        } else {
            console.warn(
                'setUpSquareMetersCalculation: ui.width or ui.height missing'
            );
        }

        function updateSquareMeters() {
            var value = (ui.width.val() * ui.height.val()) / 1000000;
            ui.squareMeters.val(value);
        }
    }

    return {
        loadProductInputToEdit: loadProductInputToEdit,
        loadProducttypeInput: loadProducttypeInput,
    };
})();

export default {
    mixins: [localization],
    mounted() {
        window.productForGroupSelected = this.productForGroupSelected;
        window.retourSelected = this.retourSelected;
        window.onChangeEditRaltype = this.onChangeEditRaltype;
        window.onChangeEditRalnr = this.onChangeEditRalnr;
        window.onChangeInputRaltype = this.onChangeInputRaltype;
        window.onChangeInputRalnr = this.onChangeInputRalnr;
        window.clearLinkProduct = this.clearLinkProduct;
        window.changeGeneric = this.changeGeneric;
        window.colorSelected = this.colorSelected;
        window.colorEditSelected = this.colorEditSelected;
        this.initCopyServiceOrderProduct();
    },
    methods: {
        //Datatype table generates two filter fields to generate a list coming from a generic table
        //When one of the filter fields is changd, this method is called to filter
        changeGeneric(
            table,
            tableKey,
            tableField,
            tableField2,
            filter,
            listId,
            fieldId,
            callbackFunction
        ) {
            const self = this;
            //one of both fields must contain at least 2 characters
            if (
                $('#' + tableField).val().length >= 2 ||
                $('#' + tableField2).val().length >= 2
            ) {
                self.fillGenericList(
                    table,
                    tableKey,
                    tableField,
                    tableField2,
                    $('#' + tableField).val(),
                    $('#' + tableField2).val(),
                    filter,
                    listId,
                    fieldId,
                    callbackFunction
                );
            }
        },
        /**
         * Generate a generic list based on 2 fields to filter on
         * @param table The name of the table to get records from
         * @param tableKey The name of the column to use as identifier
         * @param tableField The name of the first field to filter on
         * @param tableField2 The name of the second field to filter on
         * @param value The value for the first field entered in the filter field
         * @param value2 The value for the second field entered in the filter field
         * @param filter An extra filter to add to the query
         * @param listId The id of the list to fill with the results
         * @param fieldId The id of the field to add the selection from the list to
         */
        fillGenericList(
            table,
            tableKey,
            tableField,
            tableField2,
            value,
            value2,
            filter,
            listId,
            fieldId,
            callbackFunction
        ) {
            genericApi
                .listGeneric(
                    table,
                    tableKey,
                    tableField,
                    tableField2,
                    value,
                    value2,
                    filter
                )
                .then((response) => {
                    const data = response.data;
                    var fn = callbackFunction || setValForField;

                    if (!isFunction(fn)) {
                        // For compatibility with text based onClick="" usages
                        eval(
                            'fn = function (fieldId, tblKey, description) { ' +
                                fn +
                                '(fieldId, tblKey, description); }'
                        );
                    }

                    $('#' + listId).empty();
                    var list = data.data;

                    for (var i = 0; i < list.length; i++) {
                        var tblKey = list[i].tableKey; //TableKey is saved under string 'tableKey' and not under it's value as the fields
                        //Save field with key
                        var description = escapeHtml(list[i][tableField2]);

                        tblKey = tblKey.replace(/[|&;$%@"'<>()+,]/g, '');

                        var newEl = $(
                            '<li><a href id="' +
                                tblKey +
                                '" >' +
                                list[i][tableField] +
                                ' - ' +
                                list[i][tableField2] +
                                '</a></li>'
                        );
                        newEl.data('fieldId', fieldId);
                        newEl.data('tblKey', tblKey);
                        newEl.data('description', description);
                        newEl.off().on('click', function () {
                            var e = $(this);
                            fn(
                                e.data('fieldId'),
                                e.data('tblKey'),
                                e.data('description'),
                                e
                            );
                            return false;
                        });
                        $('#' + listId).append(newEl);
                    }

                    $('#' + listId)
                        .listview()
                        .listview('refresh');
                });

            const entityMap = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;',
                '/': '&#x2F;',
                '`': '&#x60;',
                '=': '&#x3D;',
            };
            function escapeHtml(string) {
                return String(string).replace(/[&<>"'`=\/]/g, function (s) {
                    return entityMap[s];
                });
            }
        },

        clearLinkProduct() {
            $('#linkToProductField').val('');
        },
        onChangeInputRaltype() {
            //raltype is mostly 1 digit
            if ($('#raltypeField').val().length >= 1) {
                this.searchColor(
                    $('#ralnrField').val(),
                    $('#raltypeField').val()
                );
            }
        },
        onChangeInputRalnr() {
            if ($('#ralnrField').val().length >= 2) {
                this.searchColor(
                    $('#ralnrField').val(),
                    $('#raltypeField').val()
                );
            }
        },
        searchColor(ralnr, raltype) {
            const payload = {};

            if (ralnr && ralnr.length >= 2) {
                payload.ralnr = ralnr;
            }
            //raltype is mostly 1 digit long
            if (raltype && raltype.length >= 1) {
                payload.raltype = raltype;
            }
            colorApi.list(payload).then((response) => {
                const data = response.data;
                $('#inputcolorlist').empty();
                var profileArray = data.data;
                for (var i = 0; i < profileArray.length; i++) {
                    var descr =
                        profileArray[i].ralnr +
                        ' ' +
                        profileArray[i].raltype +
                        ' ' +
                        profileArray[i].poedernr +
                        ' ' +
                        profileArray[i].producent;
                    descr = descr.replace(/\s+/g, '');
                    $('#inputcolorlist').append(
                        '<li><a onClick=colorSelected("' +
                            profileArray[i].id +
                            '","' +
                            descr +
                            '") id="' +
                            profileArray[i].id +
                            '" >' +
                            profileArray[i].ralnr +
                            ' ' +
                            profileArray[i].raltype +
                            ' ' +
                            profileArray[i].poedernr +
                            ' ' +
                            profileArray[i].producent +
                            ' - ' +
                            profileArray[i].description +
                            '</a></li>'
                    );
                }
                $('#inputcolorlist').listview().listview('refresh');
            });
        },
        colorSelected(colorid, descr) {
            $('#colorField').val(colorid);
            $('#addproductcolorlbl').text(descr);
        },
        colorEditSelected(colorid, descr) {
            $('#editColorField').val(colorid);
            $('#editproductcolorlbl').text(descr);
        },
        searchEditColor(ralnr, raltype) {
            var payLoad = {};

            if (ralnr && ralnr.length >= 2) {
                payLoad.ralnr = ralnr;
            }
            //raltype is mostly 1 digit long
            if (raltype && raltype.length >= 1) {
                payLoad.raltype = raltype;
            }

            colorApi.list(payLoad).then((response) => {
                const data = response.data;

                $('#editcolorlist').empty();
                var profileArray = data.data;
                for (var i = 0; i < profileArray.length; i++) {
                    var descr =
                        profileArray[i].ralnr +
                        ' ' +
                        profileArray[i].raltype +
                        ' ' +
                        profileArray[i].poedernr +
                        ' ' +
                        profileArray[i].producent;
                    descr = descr.replace(/\s+/g, '');
                    $('#editcolorlist').append(
                        '<li><a onClick=colorEditSelected("' +
                            profileArray[i].id +
                            '","' +
                            descr +
                            '") id="' +
                            profileArray[i].id +
                            '" >' +
                            profileArray[i].ralnr +
                            ' ' +
                            profileArray[i].raltype +
                            ' ' +
                            profileArray[i].poedernr +
                            ' ' +
                            profileArray[i].producent +
                            '</a></li>'
                    );
                }
            });
        },
        onChangeEditRaltype() {
            if ($('#editRaltypeField').val().length >= 1) {
                this.searchEditColor(
                    $('#editRalnrField').val(),
                    $('#editRaltypeField').val()
                );
            }
        },
        onChangeEditRalnr() {
            if ($('#editRalnrField').val().length >= 2) {
                this.searchEditColor(
                    $('#editRalnrField').val(),
                    $('#editRaltypeField').val()
                );
            }
        },
        retourSelected(profileId) {
            $('#retourfield').val(profileId);
        },
        productForGroupSelected(profileId) {
            $('#linkToProductField').val(profileId);
        },
        initCopyServiceOrderProduct() {
            //setToFlow is 3 for service orders only
            ProductHelper.loadProductInputToEdit(
                this.$route.query.productId,
                3,
                this.trans
            );
        },

        //Save the product as copy of the original. We used editproduct.html to do so and will get fields from editproduct.html
        // but use the addProductToServer function to save it
        saveCopyServiceOrderProduct() {
            //NOTE: using productDetails to get the possible fields limits the product data to the fields already added to this product
            //So make sure all fields, also the empty ones, have been added to this product when it is created

            //get product details to know which fields to save
            productTypeApi
                .productTypeDetails($route.query.typeId)
                .then((response) => {
                    const data = response.data;
                    //get basic fields of product
                    var name = $('#editNameField').val();
                    var reference = $('#editReferenceField').val();
                    var price = $('#editPriceField').val().replace(',', '.');
                    var flow = $('#flow').val();
                    var count = $('#editCountField').val();
                    var note = $('#editNoteField').val();
                    var color = $('#editColorField').val();
                    //it's possible this product needs to be linked in a group to another product
                    var linkToProductId = $('#linkToProductField').val();
                    //Possibly, this product is linked to a retour product
                    var retourProductId = $('#retourfield').val();
                    var squareMeters = $('#squareMetersField').val();

                    if (reference == '' || flow == '') {
                        return showErrorMessage(
                            this.trans(
                                'pages.copeserviceorderproduct.required_fields_error'
                            )
                        );
                    }

                    var fields = data.data.datafields;
                    var arr = new ErpMap(this.trans);
                    for (var i = 0; i < fields.length; i++) {
                        var value = '';
                        const field = fields[i];
                        switch (parseInt(field.datatype)) {
                            case 1:
                                if (
                                    $('#' + field.datafieldId).attr(
                                        'checked'
                                    ) == 'checked'
                                ) {
                                    value = 1;
                                } else {
                                    value = 0;
                                }
                                break;
                            default:
                                //by default, no additional validation is necessary
                                value = $('#' + field.datafieldId).val();
                                break;
                        }

                        if (field.mandatory == 1 && value == '') {
                            return showErrorMessage(
                                this.trans(
                                    'pages.copeserviceorderproduct.required_fields_error'
                                )
                            );
                        }

                        arr.put(field.datafieldId, value); // The id of each field is the name as saved in the DB
                    }

                    //save product to server and redirect to correct page in case of success
                    this.saveServiceOrderProductToServer(
                        $route.query.orderId,
                        $route.query.typeId,
                        name,
                        reference,
                        color,
                        count,
                        price,
                        note,
                        flow,
                        linkToProductId,
                        retourProductId,
                        arr,
                        $route.query.productId,
                        squareMeters
                    );
                });
        },
        saveServiceOrderProductToServer(
            oId,
            ptId,
            name,
            reference,
            color,
            count,
            price,
            note,
            flow,
            linkToProductId,
            retourProductId,
            fields,
            originalProductId,
            squareMeters
        ) {
            const payload = {};
            payload.producttypeId = ptId;
            payload.orderId = oId;
            payload.price = price;
            payload.note = note;
            payload.name = name;
            payload.reference = reference;
            payload.color = color;
            payload.count = count;
            payload.flow = flow;
            payload.employeeId =
                window.vuexStore.getters['currentUser/getUserId'];
            payload.linkToProductId = linkToProductId; // id of the product to combine this product with in one group
            payload.originalProduct = originalProductId; // id of the product to combine this product with in one group
            payload.retourProductId = retourProductId;
            payload.squareMeters = squareMeters;

            for (var i = 0; i < fields.size(); i++) {
                payload[fields.keySet()[i]] = fields.valSet()[i];
            }

            productApi.addServiceOrderProduct(payload).then(() => {
                this.$router.push(
                    '/editproduct?orderId=' +
                        oId +
                        '&productTypeId=' +
                        producttype +
                        '&productState=add-product'
                );
            });
        },
    },
};
</script>
